import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledDialogActions } from './styles';

interface DialogActionButtonsProps {
  noMargin?: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
  disabled?: boolean;
  cancelButtonLabel?: string;
  showConfirmButton?: boolean;
}

export const DialogActionButtons = ({
  noMargin,
  onCancel,
  onConfirm,
  disabled,
  cancelButtonLabel,
  showConfirmButton = true,
}: DialogActionButtonsProps) => {
  const { t } = useTranslation();
  const cancelButton = cancelButtonLabel || t('actions.cancel');
  const confirmButton = t('actions.confirm');
  return (
    <StyledDialogActions noMargin={noMargin}>
      <Button variant="outlined" onClick={onCancel}>
        {cancelButton}
      </Button>
      {showConfirmButton && (
        <Button onClick={onConfirm} type="submit" variant="contained" disabled={disabled}>
          {confirmButton}
        </Button>
      )}
    </StyledDialogActions>
  );
};
